import {useTranslation} from 'react-i18next';

import {Box, keyframes, Typography} from '@mui/material';

import {MaintainIcon} from '../assets/icons/index';
import EmpionLogo from '../components/EmpionLogoAnimation/EmpionLogo';

import {greenColors} from './theme/designSystem';

export const MaintenanceMode = () => {
  const {t} = useTranslation();

  const spinnerLogo = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
    
  `;
  const logoStyles = {
    animation: `${spinnerLogo} 10s linear infinite`,
    width: {xs: '200px', sm: '250px'},
    height: {xs: '200px', sm: '250px'},
    margin: '0 auto',
    marginTop: '30px',
  };

  return (
    <Box sx={{textAlign: 'center', padding: '50px'}}>
      <EmpionLogo fill={greenColors[70]} />
      <Typography variant='h1' gutterBottom>
        {t('shared.maintainance.title')}
      </Typography>
      <Typography variant='h4' textAlign={'center'} sx={{maxWidth: '500px', margin: '0 auto'}}>
        {t('shared.maintainance.message')}
      </Typography>
      <Box sx={logoStyles} data-testid='maintenance-logo'>
        <MaintainIcon fill={greenColors[100]} />
      </Box>
    </Box>
  );
};
